import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IPlanosSales } from '../interfaces/planos_sales.interface';
import { ResultApi } from '../viewModel/result_api.model';
import {
	BASICO,
	BASICO_TRIPLO,
	BLACK,
	BLACK_TRIPLO,
	COMPLETO,
	COMPLETO_TRIPLO,
	COUNT_DIARIAS_DEFAULT,
	COUNT_MAX_DIARIAS_DEFAULT,
	EXCLUSIVO,
	EXCLUSIVO_TRIPLO,
	IDEAL,
	IDEAL_TRIPLO,
	PLUS,
	PLUS_TRIPLO,
	REQUINTE,
	REQUINTE_TRIPLO
} from '../../app.constants';
import { IPlanCart } from '../../shared/interfaces/cart.interface';
import {
	BASICO_TEXT,
	BASICO_TEXT_1,
	BASICO_TEXT_2,
	BLACK_TEXT,
	BLACK_TEXT_1,
	BLACK_TEXT_2,
	COMPLETO_TEXT,
	COMPLETO_TEXT_1,
	COMPLETO_TEXT_2,
	EXCLUSIVO_TEXT,
	EXCLUSIVO_TEXT_1,
	EXCLUSIVO_TEXT_2,
	IDEAL_TEXT,
	IDEAL_TEXT_1,
	IDEAL_TEXT_2,
	PLUS_TEXT,
	PLUS_TEXT_1,
	PLUS_TEXT_2,
	REQUINTE_TEXT,
	REQUINTE_TEXT_1,
	REQUINTE_TEXT_2
} from '../constants/planos_text.constant';
import { Planos } from '../viewModel/planos.model';

@Injectable({ providedIn: 'root' })
export class ProductService extends BaseService {

	private minDaily = COUNT_DIARIAS_DEFAULT;
	private maxDaily = COUNT_MAX_DIARIAS_DEFAULT;
	constructor(private httpClient: HttpClient) {
		super(httpClient);
	}

	public async products(reload: boolean = false): Promise<ResultApi> {
		return this.httpClient
			.get<IPlanosSales>(`${this.salesUrl}/produtos/${this.idPriceBook}`, {})
			.toPromise()
			.then((res: any) => {
				if (res) {
					return new ResultApi().toResult({status: 202,  data: res, error: null});
				}
			}).catch(async (err: any) => {
				if (!reload) {
					return await this.products(true);
				}
				return err;
			});
	}

	public async plans() {
		const result = await this.products();
		if(result) {
			return this.setPlans(result.data);
		}
		return this.setPlans([])
	}

	public onlyByType(type: 'DOUBLE' | 'TRIPLE', plans: Array<IPlanCart>, min: number = this.minDaily) {
		plans = this.filterPlansByType(plans, type);
		plans.forEach(value => value.description = this.cleanDescriptionByType(type, value.description.toLowerCase()));
		plans = this.adjustDescription(plans);
		return this.minDiary(plans, min);
	}

	public monthlyValueString(description: string) {
		const value = description
			.split('R$')[1]
			.replace('.', ',')
			.replace('*', '');
		return 'R$ ' + value;
	}

	public getText(categoryCode: string, value: string = '', textType: number = 0) {
		switch (categoryCode) {
			case BASICO :
			case BASICO_TRIPLO : {
				return this.setText(textType, BASICO_TEXT, BASICO_TEXT_1, BASICO_TEXT_2, value);
			}
			case COMPLETO :
			case COMPLETO_TRIPLO : {
				return this.setText(textType, COMPLETO_TEXT, COMPLETO_TEXT_1, COMPLETO_TEXT_2, value);
			}
			case IDEAL :
			case IDEAL_TRIPLO : {
				return this.setText(textType, IDEAL_TEXT, IDEAL_TEXT_1, IDEAL_TEXT_2, value);
			}
			case EXCLUSIVO:
			case EXCLUSIVO_TRIPLO : {
				return this.setText(textType, EXCLUSIVO_TEXT, EXCLUSIVO_TEXT_1, EXCLUSIVO_TEXT_2, value);
			}
			case REQUINTE:
			case REQUINTE_TRIPLO : {
				return this.setText(textType, REQUINTE_TEXT, REQUINTE_TEXT_1, REQUINTE_TEXT_2, value);
			}
			case PLUS:
			case PLUS_TRIPLO : {
				return this.setText(textType, PLUS_TEXT, PLUS_TEXT_1, PLUS_TEXT_2, value);
			}
			case BLACK:
			case BLACK_TRIPLO : {
				return this.setText(textType, BLACK_TEXT, BLACK_TEXT_1, BLACK_TEXT_2, value);
			}
			default: {
				return '';
			}
		}
	}

	public transitionTypeByCategoryCode(categoryCode: string) {
		switch (categoryCode) {
			case BASICO : {
				return BASICO_TRIPLO;
			}
			case BASICO_TRIPLO : {
				return BASICO;
			}
			case COMPLETO : {
				return COMPLETO_TRIPLO;
			}
			case COMPLETO_TRIPLO : {
				return COMPLETO;
			}
			case IDEAL : {
				return IDEAL_TRIPLO;
			}
			case IDEAL_TRIPLO : {
				return IDEAL;
			}
			case EXCLUSIVO: {
				return EXCLUSIVO_TRIPLO;
			}
			case EXCLUSIVO_TRIPLO : {
				return EXCLUSIVO;
			}
			case REQUINTE: {
				return REQUINTE_TRIPLO;
			}
			case REQUINTE_TRIPLO : {
				return REQUINTE;
			}
			case PLUS: {
				return PLUS_TRIPLO;
			}
			case PLUS_TRIPLO : {
				return PLUS;
			}
			case BLACK: {
				return BLACK_TRIPLO;
			}
			case BLACK_TRIPLO : {
				return BLACK;
			}
			default: {
				return categoryCode;
			}
		}
	}


	public transformInPlans(plans: Array<Planos>) {
		return plans.map((plan) => {
			const planCart: IPlanCart = {
				dailies: plan.qtdDiarias.map((qtdDiaria) => {
					const daily: IPlanCart['dailies'][0] = {
						value: qtdDiaria.valor,
						description: qtdDiaria.descricao,
						categoryCode: plan.codigoCategoria,
						dailyQuantity: qtdDiaria.quantidadeDiarias,
						categoryDescription: plan.descricao,
					}
					return daily;
				}),
				unitPrice: plan.precoUnitario,
				description: plan.descricao,
				categoryCode: plan.codigoCategoria,
				salesCategoryCode: plan.codigoCategoriaSales,
			}
			return planCart;
		});
	}

	transformInPlanos(plans: Array<IPlanCart>) {
		const planos: Array<Planos> = [];
		plans.forEach((plan) => {
			const plano: Planos = {
				codigoCategoriaSales: '',
				codigoCategoria: '',
				descricao: '',
				qtdDiarias: [],
				images: [],
				precoUnitario: 0,
			}
			planos.push(plano);
		});
		return planos;
	}

	private filterPlansByType(plans: Array<IPlanCart>, type: 'DOUBLE' | 'TRIPLE') {
		if(type === 'DOUBLE') {
			return plans.filter(plan => {
				return (
					plan.categoryCode !== BASICO_TRIPLO    &&
					plan.categoryCode !== COMPLETO_TRIPLO  &&
					plan.categoryCode !== IDEAL_TRIPLO     &&
					plan.categoryCode !== EXCLUSIVO_TRIPLO &&
					plan.categoryCode !== REQUINTE_TRIPLO  &&
					plan.categoryCode !== PLUS_TRIPLO      &&
					plan.categoryCode !== BLACK_TRIPLO
				);
			});
		}

		if (type === 'TRIPLE') {
			return plans.filter(plan => {
				return (
					plan.categoryCode !== BASICO    &&
					plan.categoryCode !== COMPLETO  &&
					plan.categoryCode !== IDEAL     &&
					plan.categoryCode !== EXCLUSIVO &&
					plan.categoryCode !== REQUINTE  &&
					plan.categoryCode !== PLUS      &&
					plan.categoryCode !== BLACK
				);
			});
		}
	}

	private setPlans(data: Array<IPlanosSales>) {
		const plans: Array<IPlanCart> = [];
		data.forEach((sales) => {
			if(
				sales.Product2.Name !== 'Taxa de Adesão' &&
				sales.Product2.Name !== 'Taxa de Adesăo' &&
				sales.Product2.Name !== 'Básico Duplo' &&
				sales.Product2.Name !== 'Básico Triplo'
			) {
				const name = sales.Product2.Name;
				const unitPrice = sales.UnitPrice;
				const categoryCode = this.getCategoryCodeByName(name);
				const plan: IPlanCart = {
					dailies: this.setNumberOfDays(name, categoryCode, unitPrice),
					unitPrice,
					description: (name == '') ? this.getPlanByCategoryCode(categoryCode) : name,
					categoryCode,
					salesCategoryCode: sales.Product2Id,
				}
				plans.push(plan);
			}
		});
		return plans.sort((a, b) => a.unitPrice < b.unitPrice ? -1 : a.unitPrice < b.unitPrice ? 1 : 0);
	}

	private getCategoryCodeByName(name: string): string {
		switch (name) {
			case 'Básico Duplo': {
				return '05';
			}
			case 'Básico Triplo': {
				return '80';
			}
			case 'Completo Duplo': {
				return '08';
			}
			case 'Completo Triplo': {
				return '83';
			}
			case 'Ideal Duplo': {
				return '11';
			}
			case 'Ideal Triplo': {
				return '86';
			}
			case 'Exclusivo Duplo': {
				return '14';
			}
			case 'Exclusivo Triplo': {
				return '89';
			}
			case 'Requinte Duplo': {
				return '17';
			}
			case 'Requinte Triplo': {
				return '92';
			}
			case 'Plus Duplo': {
				return '28';
			}
			case 'Plus Triplo': {
				return '95';
			}
			case 'Black Duplo': {
				return'31';
			}
			case 'Black Triplo': {
				return'98';
			}
			default: {
				return '0';
			}
		}
	}

	private getPlanByCategoryCode(categoryCode: string) {
		switch (categoryCode) {
			case '05': {
				return 'Básico Duplo';
			}
			case '80': {
				return 'Básico Triplo';
			}
			case '08': {
				return 'Completo Duplo';
			}
			case '83': {
				return 'Completo Triplo';
			}
			case '11': {
				return 'Ideal Duplo';
			}
			case '86': {
				return 'Ideal Triplo';
			}
			case '14': {
				return 'Exclusivo Duplo';
			}
			case '89': {
				return 'Exclusivo Triplo';
			}
			case '17': {
				return 'Requinte Duplo';
			}
			case '92': {
				return 'Requinte Triplo';
			}
			case '28': {
				return 'Plus Duplo';
			}
			case '95': {
				return 'Plus Triplo';
			}
			case '31': {
				return'Black Duplo';
			}
			case '98': {
				return 'Black Triplo';
			}
			default: {
				return '0';
			}
		}
	}

	private setNumberOfDays(name: string, categoryCode: string, unitPrice: number) {
		const numberOfDays: IPlanCart['dailies'] = [];
		for (let daily = this.minDaily; daily <= this.maxDaily; daily++) {
			const value = Number((daily * unitPrice / 12).toFixed(2));
			const amountOfDaily: IPlanCart['dailies'][0] = {
				value,
				description: daily + ' diárias - 12 mensalidades de R$ ' + value,
				categoryCode,
				dailyQuantity: daily,
				categoryDescription: name,
			}
			numberOfDays.push(amountOfDaily);
		}
		return numberOfDays;
	}

	private cleanDescriptionByType(type: 'DOUBLE' | 'TRIPLE', plan: string) {
		const replaceType = type === 'DOUBLE' ? 'duplo' : 'triplo';
		plan = plan.toLowerCase();
		return plan.replace(replaceType, '').toUpperCase().trim();
	}

	private adjustDescription(plans: Array<IPlanCart>) {
		return plans.map((plan) => {
			const discount = plan.description.toLowerCase();
			if(discount !== null) {
				plan.description =  discount.charAt(0).toUpperCase() + discount.slice(1);
				if(plan.description.trim() === 'Basico') {
					plan.description = 'Básico';
				}
			}
			return plan;
		});
	}

	private minDiary(plans: Array<IPlanCart>, min: number) {
		return plans.map((plan) => {
			if (plan.description === 'Básico') {
				plan.dailies = plan.dailies.filter(v => v.dailyQuantity >= this.minDaily);
				return plan;
			}
			plan.dailies = plan.dailies.filter(v => v.dailyQuantity >= min);
			return plan;
		});
	}

	private getTextWithPrice(text: string, value: string) {
		return text.replace('R$ 000,00', value);
	}

	private setText(textType: number, text: string, text1: string, text2: string, value: string) {
		if (textType === 0) {
			return text;
		}
		return textType === 1 ? text1 : this.getTextWithPrice(text2, value);
	}
}
